import { ShieldIcon } from "@cynthai/icons";
import { Button } from "@cynthai/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { m } from "@/paraglide/messages";

export const Route = createFileRoute("/_protected/not-authorized/")({
  component: NotAuthorizedPage,
});

function NotAuthorizedPage() {
  const navigate = useNavigate();

  return (
    <main
      className={`flex min-h-screen items-center justify-center rounded-lg px-4 py-20`}
      aria-labelledby="not-authorized-title"
    >
      <div
        className={`bg-background-2 text-text-primary shadow-card w-full max-w-xl rounded-md p-8 text-center`}
      >
        <div
          className={`text-primary-600 mx-auto mb-3 inline-flex items-center justify-center rounded-[18px] shadow-[0_6px_18px_rgba(0,0,0,0.06)]`}
          aria-hidden
        >
          <ShieldIcon width={56} height={56} />
        </div>

        <h1
          id="not-authorized-title"
          className="text-text-primary my-2 mb-3 text-[20px] font-semibold"
        >
          {m.not_authorized()}
        </h1>

        <p className="text-text-secondary mb-10">
          {m.not_authorized_message()}
        </p>

        <div className="mt-1.5 flex flex-wrap justify-center gap-3">
          <Button
            onClick={() => window.history.back()}
            className={`border-border bg-secondary-elements text-text-primary cursor-pointer rounded-lg border px-3.5 py-2`}
          >
            {m.go_back()}
          </Button>

          <Button
            onClick={() => navigate({ to: "/" })}
            className={`bg-primary inline-block rounded-lg px-3.5 py-2 text-white no-underline`}
          >
            {m.go_to_home()}
          </Button>
        </div>
      </div>
    </main>
  );
}
